import React, { useEffect } from "react";

import styles from "./HotKey.module.css";

type HotKeyPropTypes = {
  char: string;
  right?: number;
  metaKey?: boolean;
  ctrlKey?: boolean;
  onTrigger?: () => void;
};

const HotKey: React.FC<HotKeyPropTypes> = ({ char, right = 12, metaKey = false, ctrlKey = false, onTrigger }) => {
  const triggerListener = (event: KeyboardEvent) => {
    if (!onTrigger) return;
    if (metaKey && !event.metaKey) return;
    if (ctrlKey && !event.ctrlKey) return;

    if (event.key === char.toLowerCase()) onTrigger();
  };

  useEffect(() => {
    window.addEventListener("keydown", triggerListener);
    return () => {
      window.removeEventListener("keydown", triggerListener);
    };
  });

  return (
    <div
      className={styles.container}
      style={{
        right: `${right}px`,
      }}
    >
      {metaKey && <Key value="⌘" />}
      {ctrlKey && <Key value="ctrl" />}
      <Key value={char} upper />
    </div>
  );
};

type KeyPropTypes = {
  value: string;
  upper?: boolean;
};

const Key: React.FC<KeyPropTypes> = ({ value, upper = false }) => (
  <i className={styles.key}>{upper ? value.toUpperCase() : value}</i>
);

export default HotKey;
